export default function authorOwnerCheck(id, permissionId) {
  return permissionId === Number(id);
}



// WEBPACK FOOTER //
// ./app/javascript/client/utils/authorOwnerCheck.js